import { Link, LinkProps } from "react-router-dom";

import { Anchor, AnchorProps } from "@mantine/core";

interface AnchorLinkProps extends AnchorProps {
  to: LinkProps["to"];
  children: React.ReactNode;
  state?: LinkProps["state"];
}

export default function AnchorLink({ to, state, ...props }: AnchorLinkProps) {
  return <Anchor {...props} renderRoot={(props) => <Link to={to} state={state} {...props} />} />;
}
